import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import education_png from "./education.png";

const education = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Productos | Academia de DevOps y Full-Stack</title></Helmet>

      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>

          <h1> Academia DevOps : Clase magistral de DevOps en la nube (Python, Terraform, AWS)</h1>

          <hr className={classes['bh-divider']}/>
          <h2> Duración del programa: 3 Meses (Opciones de forma intensiva o a tiempo parcial)</h2>
          <ul>

            <li>¿Es usted un desarrollador que siente la presión de acortar la distancia entre
               el código y la implementación?
            </li>
            <li>
             ¿Tienes conocimientos básicos de programación, pero la infraestructura en la nube 
             y la entrega continua aún te resultan un misterio?
            </li>

          </ul>
          <p>

            Únete a nuestra clase magistral de DevOps en la nube: 
            la vía rápida para convertirte en un ingeniero de DevOps en la nube muy solicitado.
          </p>

         <h3>¿Para quién es este curso?</h3>

         <ul>
           <li>
            Desarrolladores: listos para dominar todo el ciclo de vida del desarrollo de software, desde el código hasta la nube.
           </li>

           <li>
             Administradores de sistemas y profesionales de TI que buscan modernizar sus habilidades con la nube y la automatización.
            </li>
          <li>
            Ingenieros de software junior: buscan convertirse en profesionales versátiles tipo “T” y acelerar su carrera.
          </li>

           <li>
             Cualquier persona con experiencia básica en lógica de programación que quiera realizar la transición a roles DevOps de alta demanda.
           </li>

         </ul>

          <h3>Lo que dominarás en 3 meses</h3>

          <p>

            <strong>Modulo 1:</strong> Fundamentos de la nube y DevOps con los servicios principales de AWS (Mes 1)
            <ul>
              <li>Introdución a DevOps: Principios, cultura y metodologías de la ingeniería de software (CI/CD, SRE, Agile).</li>
              <li>Fundamentos de AWS: navegación por la consola de AWS, IAM, VPC, EC2, S3, RDS, CloudWatch. </li>

              <li>Linux y Shell Scripting para DevOps: Domina los comandos esenciales y automatiza con potentes scripts.</li>

              <li>Git y control de versiones: Flujos de trabajo avanzados para el desarrollo colaborativo. </li>

              <li>Fundamentos de Python para DevOps: Creación de scripts para la automatización de sistemas e interacción con API (introducción a Boto3).</li>

              <li>Primer proyecto: Implementación de una aplicación web sencilla en AWS EC2 mediante pasos manuales y scripts básicos de Python.</li>
            </ul>
          </p>
          <p>
            <strong>Modulo 2:</strong> Infraestructura como código y automatización con Terraform y AWS avanzado (mes 2)
            <ul>
            <li>
            Introducción a Infraestructura como Código (IaC): Por qué IaC, idempotencia, gestión de estados.
            </li>
            <li>
            Análisis profundo de Terraform: sintaxis HCL, proveedores, recursos, fuentes de datos, módulos, espacios de trabajo.
            </li>

            <li>
            Automatización de AWS con Terraform: implementación de arquitecturas complejas de AWS (VPC, EC2, balanceadores de carga, grupos de escalado automático, RDS) 
            completamente mediante código.
            </li>

            <li>
             Python avanzado para AWS: uso de Boto3 para la gestión dinámica de recursos, funciones Lambda para la automatización basada en eventos.
            </li>

            <li>
            Contenerización con Docker: creación, gestión y orquestación de contenedores.
            </li>
            <li>
            Proyecto intermedio: construcción de una infraestructura de aplicaciones escalable y tolerante a fallas en AWS utilizando Terraform y Docker.
            </li>
            </ul>
          </p>
          <p>
            <strong>Modulo 3: CI/CD,</strong> Orquestación y monitorización de contenedores en AWS (Mes 3)
            <ul>
              <li>
            Integración Continua/Entrega Continua (CI/CD): Principios e implementación del pipeline.
              </li>
              <li>
             Servicios de CI/CD de AWS: AWS CodePipeline, CodeBuild, CodeDeploy.
              </li>
              <li>
             Orquestación de contenedores con Amazon ECS/EKS: Implementación y gestión de aplicaciones en contenedores a escala.
               </li>
              <li>
             Python avanzado para CI/CD: Creación de scripts personalizados de compilación e implementación, integración con herramientas de CI/CD.
              </li>
              <li>
             Monitoreo y registro: implementación de CloudWatch, ELK/Grafana para observabilidad.
              </li>
              <li>
             Mejores prácticas de seguridad de DevOps: roles de IAM, grupos de seguridad, WAF, gestión de secretos (AWS Secrets Manager).
              </li>
              <li>
              Proyecto final: diseñar, implementar y automatizar una aplicación nativa de la nube completa en AWS, incorporando todas las prácticas de DevOps aprendidas, CI/CD.
              </li>
            </ul>
          </p>

          <h3>¿Por qué elegir Backend Helpers Devops Academy?</h3>

          <p>

          <ul>
            <li>
            100% práctico: desarrolla habilidades reales con laboratorios inmersivos y proyectos del mundo real.
            </li>
            <li>
            Instructores expertos en la industria: impartidos por ingenieros de DevOps en la nube con experiencia que trabajan activamente en el campo.
            </li>
            <li>
            Instructores expertos en la industria: impartidos por ingenieros de DevOps en la nube con experiencia que trabajan activamente en el campo.
            </li>
            <li>
            Apoyo profesional dedicado: talleres de currículum, preparación para entrevistas y asistencia para la colocación laboral.
            </li>
            <li>
            Construya un portafolio poderoso: gradúese con proyectos demostrables que muestren su experiencia.
            </li>
            <li>           
           Clases reducidas: atención personalizada y acompañamiento mediante tutorías.
            </li>
          </ul>
          </p>

          <img src={education_png}  alt="Devops Academy" className={classes['img-tech']}/>

        </section>
        </main>

    </div>
  );
};
export default education;